__turbopack_context__.v({
  "actionButton": "fNuZXG_actionButton",
  "backgroundImage": "fNuZXG_backgroundImage",
  "compact": "fNuZXG_compact",
  "component": "fNuZXG_component",
  "infoBox": "fNuZXG_infoBox",
  "infoBoxBodyWrapper": "fNuZXG_infoBoxBodyWrapper",
  "infoBoxContent": "fNuZXG_infoBoxContent",
  "loadingSpinner": "fNuZXG_loadingSpinner",
  "logo": "fNuZXG_logo",
  "wrapper": "fNuZXG_wrapper",
});
